import { UiService } from 'app/shared/services/ui/ui.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { OpenDialogAddEditParameterComponent } from 'app/components/dialog/open-dialog-add-edit-parameter/open-dialog-add-edit-parameter.component';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-admin-parameters',
  templateUrl: './admin-parameters.component.html',
  styleUrls: ['./admin-parameters.component.scss']
})
export class AdminParametersComponent implements OnInit {

  searchForm: UntypedFormGroup;
  valueInput: string;
  userConnected: any;
  clubCode: any;
  title: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private authService: AuthService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private faIconService: FaiconService,
    private uiSrv: UiService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataService.valueFilterParameter$.next(filterValue);
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  addOrEditParameter(action: string, parameter?: any): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditParameterComponent, {
      data: { action, parameter },
      maxHeight: '80%',
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        // this.dataService.clubActiveParameters$.next(res.data);
        this.dataService.updatedParameters$.next(true);
        this.uiSrv.showSnackbar('Paramètre ajouté avec succès');
      }
    });
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();

    this.title = 'Liste des paramètres';
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }
}
